import Item from './Item'
import UnorderedList from './UnorderedList'

UnorderedList.Item = Item

export default UnorderedList



// WEBPACK FOOTER //
// ./src/components/UnorderedList/index.js